export const getCompanySelector = store => {
    return store.getIn(["companies", "companies"])
}